import type { MaybeRef } from "vue"
import type { ISlideshowVideoValidationResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { SlideshowVideoValidation } from "@/models"

/**
 * Validates whether a slideshow can generate a video.
 * Returns plan limits and any blocking error or non-blocking warnings.
 */
export async function validateSlideshowVideo(id: string, eventVaultId: number) {
  const endpoint = `/${eventVaultId}/slideshow/${id}/video/validation`

  const response = await v1.get<ISlideshowVideoValidationResponse>(endpoint)

  return SlideshowVideoValidation.fromResponse(response.data)
}

const VALIDATE_SLIDESHOW_VIDEO = "validateSlideshowVideo"

export function useValidateSlideshowVideo(
  id?: MaybeRef<string | undefined>,
  eventVaultId?: MaybeRef<number | undefined>,
  options: { enabled?: MaybeRef<boolean> } = {},
) {
  return useQuery({
    queryKey: [VALIDATE_SLIDESHOW_VIDEO, id, eventVaultId],
    queryFn: () => validateSlideshowVideo(toValue(id)!, toValue(eventVaultId)!),
    enabled: () => !!toValue(eventVaultId) && !!toValue(id) && (toValue(options.enabled) ?? true),
  })
}
